import React from 'react';
import PropTypes from 'prop-types';
import { User } from 'react-feather';
import classnames from 'classnames';

import { USER_SIZE_SMALL } from '../../constants/AppConstants';
import * as ChatRoles from '../../constants/Roles';

const Avatar = ({firstName, lastName, userId, user, size, type})  => {
  let avatarInitials = '';
  const fName = user ? user.firstName : firstName;
  const lName = user ? user.lastName : lastName;
  avatarInitials += fName ? fName.charAt(0) : '';
  avatarInitials += lName ? lName.charAt(0) : '';

  return (
    <div className={classnames({
      "avatar": true,
      "avatar-small": size === USER_SIZE_SMALL,
      "avatar-sender": type === ChatRoles.SENDER
    })}>
      {avatarInitials !== '' ? avatarInitials : <User size={16} />}
    </div>
  );
};

Avatar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  user: PropTypes.object,
  userId: PropTypes.number,
  size: PropTypes.string,
  type: PropTypes.string
};

export default Avatar;
